module.exports = __webpack_public_path__ + "assets/green_check_mark-bb3c74.svg";